import React from 'react'
import Layout from '../components/layout'

const VideoPage = () => (
    <Layout siteTitle="Video">
        <h1 className="text-5xl sm:text-9xl text-center p-20 min-h-screen">Coming Soon</h1>
    </Layout>
)

export default VideoPage